import { render, staticRenderFns } from "./device-certificate.vue?vue&type=template&id=620a08cd&scoped=true"
import script from "./device-certificate.vue?vue&type=script&lang=js"
export * from "./device-certificate.vue?vue&type=script&lang=js"
import style0 from "./device-certificate.vue?vue&type=style&index=0&id=620a08cd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a08cd",
  null
  
)

export default component.exports